import { useTranslation } from 'next-i18next'
import React from 'react'
import FAQ, { FAQItem } from 'src/components/FAQ'

/**
 * FAQs for Almacenamiento a Domicilio — reuses the canonical
 * `src/components/FAQ` component (the same one
 * `PersonalizedLanding/FaqsSection.tsx` mounts) for visual + behavioral
 * consistency with all other pillar pages.
 *
 * The on-demand locale stores items as `{ QUESTION, ANSWER }` (uppercase) to
 * mirror the four-step process keys; the canonical FAQ component expects
 * `{ title, description }`. We map at render time rather than rewriting the
 * locale (less disruption, single hot path, types stay clean).
 */

interface IRawItem {
  QUESTION: string
  ANSWER: string
}

const FaqsOnDemand = () => {
  const { t } = useTranslation('page_almacenamiento_a_domicilio')

  const raw = t('FAQS.ITEMS', { returnObjects: true }) as unknown as
    | IRawItem[]
    | string

  const items: FAQItem[] = Array.isArray(raw)
    ? raw.map(({ QUESTION, ANSWER }) => ({
        title: QUESTION,
        description: ANSWER
      }))
    : []

  return (
    <FAQ
      title={t('FAQS.TITLE')}
      faqs={items}
      whatsappMsg={t('FAQS.WHATSAPP_MSG')}
      surface="on-demand"
    />
  )
}

export default React.memo(FaqsOnDemand)
